import { render } from "./Index.vue?vue&type=template&id=fe5ca9bc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=fe5ca9bc&lang=scss&scoped=true"

import exportComponent from "/Users/dongyucheng/小飞蛾/得乐线上化/dele-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5ca9bc"]])

export default __exports__